import { useEffect, useState } from "react";
import { useAppSelector } from "app/hooks";
import { selectUser, selectUserIsAdmin, selectUserIsUserAdmin } from "features/auth/authSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { Switch, Tooltip } from "@mui/material";
import ConfirmDeleteModal from "./modals/ConfirmDeleteModal";
import { switchStyle } from "utilities/styles/switchStyle";
import styles from "../slideShow.module.scss";
import iconStyles from "utilities/styles/iconStyles.module.scss";
import { UserRole } from "features/auth/types/user";
import { useChecklistContext } from "context/ChecklistContext";
import { useExcludePhotosFromPdfMutation } from "app/api/checklists";

const ImageFeatures = (props) => {
  const { currentVerification, currentSlide, setCurrentSlide, handleSlideshowModalClose } = props;
  const isAdmin = useAppSelector(selectUserIsAdmin);
  const isUserAdmin = useAppSelector(selectUserIsUserAdmin);
  const user = useAppSelector(selectUser);
  const [excludeFromPDF, setExcludeFromPDF] = useState<boolean>();
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const { checklist } = useChecklistContext();
  const [excludePhotosFromPdf] = useExcludePhotosFromPdfMutation();

  const isExcluded = checklist.verification[currentSlide]?.excludedFromPdf;

  // Setting the PDF state for the current verification from redux state
  useEffect(() => {
    setExcludeFromPDF(isExcluded);
  }, [currentSlide]);

  const handlePDFChange = () => {
    setExcludeFromPDF(!excludeFromPDF);
    excludePhotosFromPdf({
      checklistId: checklist.id,
      ids: [currentVerification.id],
      excluded: !excludeFromPDF,
    });
  };

  const handleCloseModal = () => {
    setConfirmDelete(false);
  };

  // Check if currentVerification is of type image (!video)
  return currentVerification.type === 1 ? (
    <>
      {confirmDelete && (
        <ConfirmDeleteModal
          // currentSlide={currentSlide}
          setCurrentSlide={setCurrentSlide}
          currentVerification={currentVerification}
          onCloseModal={handleCloseModal}
          handleSlideshowModalClose={handleSlideshowModalClose}
        />
      )}

      {isAdmin || isUserAdmin || user?.role === UserRole.SALES ? (
        <div className={styles.features}>
          <div className={styles.icons}>
            <div className={styles.includeInPDF}>
              <div className="d-flex">
                <p className={styles.includeLabel}>
                  {excludeFromPDF ? "Exkluderad från slutrapport" : "Inkluderad i slutrapport"}
                </p>

                <Tooltip arrow title="Ska bilden inkluderas i kundens slutrapport?">
                  <Switch
                    checked={!excludeFromPDF}
                    className={styles.switch}
                    sx={switchStyle}
                    onChange={handlePDFChange}
                  />
                </Tooltip>
              </div>
            </div>
            {(isAdmin || isUserAdmin) && (
              <>
                <Tooltip arrow title="Radera bilden">
                  <DeleteIcon
                    sx={{ position: "relative", top: 7 }}
                    className={iconStyles.deleteIcon}
                    onClick={() => {
                      setConfirmDelete(true);
                    }}
                  />
                </Tooltip>
              </>
            )}
          </div>
        </div>
      ) : null}
    </>
  ) : null;
};

export default ImageFeatures;
